export default __webpack_public_path__ + "static/media/icon.search.4e261425.svg";